import React, { useState } from 'react';
import { Alert, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { createUpdateBillingInfoAction } from '../../../redux/actions/investigationsActions';
import EditBillingInfo from '../Billing/EditBillingInfo';
import { BillingInfo } from '../Billing/types';

const Billing: React.FC = () => {
    const dispatch = useDispatch();
    const investigation = useSelector((state: any) => state.investigations.currentInvestigation);
    const billingInfo: BillingInfo | undefined = investigation?.billingInfo;
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    const callbackUpdate = async (values: BillingInfo) => {
        if (!investigation?.uuid) return;
        setSuccess(false);
        setError(false);
        try {
            await dispatch(createUpdateBillingInfoAction(investigation.uuid, {
                ...values,
                hospitalName: values.hospitalName || investigation.name,
            }) as any);
            setSuccess(true);
        } catch {
            setError(true);
        }
    };

    if (!billingInfo) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="info">
                    <Translate id="hospital.demo_configuration.billing.no_info" />
                </Alert>
                <Box sx={{ mt: 2 }}>
                    <EditBillingInfo
                        billingInfo={{
                            hospitalName: investigation?.name ?? '',
                            address: '',
                            city: '',
                            email: '',
                            phone: '',
                            currency: 'XOF',
                            logoBlob: '',
                        }}
                        callbackUpdate={callbackUpdate}
                    />
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3 }}>
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    <Translate id="hospital.demo_configuration.billing.save_failed" />
                </Alert>
            )}
            {success && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    <Translate id="hospital.demo_configuration.save_success" />
                </Alert>
            )}
            <EditBillingInfo billingInfo={billingInfo} callbackUpdate={callbackUpdate} />
        </Box>
    );
};

export default Billing;
